import script from "./ReclamosAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ReclamosAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ReclamosAdmin.vue?vue&type=style&index=0&id=a4eadef2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4eadef2"]])

export default __exports__